export interface StatItem {
  label: string;
  value: string;
  note: string;
}

export const siteStats: StatItem[] = [
  { label: "已归档事件", value: "214", note: "全部附时间线" },
  { label: "梳理时间节点", value: "3,860", note: "精确到日期" },
  { label: "累计阅读", value: "1,240万", note: "近一年统计" },
  { label: "读者纠错采纳", value: "97%", note: "平均响应 2 天" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "「深夜黑料」到底是做什么的？",
    a: "我们把娱乐行业已经发生的公开事件重新整理成时间线，把旧账翻出来重新捋一遍，让读者能在几分钟内看清一件事的起因、转折和结果，而不是靠零散片段去猜。",
  },
  {
    q: "这里的「深挖复盘」和普通资讯有什么区别？",
    a: "资讯只告诉你发生了什么，复盘会告诉你先后顺序和因果关系。每篇复盘都包含事件概览、时间线、关键节点解读和后续影响四个部分，信息密度更高。",
  },
  {
    q: "内容来源是哪里？会不会有主观臆断？",
    a: "所有内容只基于公开报道、官方公告和当事人公开回应整理。无法核实的部分我们会明确标注为「存疑」，不做确定性判断，也不对未公开的私人信息进行推测。",
  },
  {
    q: "发现时间线有误，可以反馈吗？",
    a: "非常欢迎。你可以通过联系页面提交纠错线索，附上可查证的公开来源，编辑组会在两个工作日内核对，确认后更新文章并在文末标注修订记录。",
  },
  {
    q: "更新频率大概是多少？",
    a: "工作日通常更新一至两篇新复盘，同时持续回补历史事件的时间线。热门事件的节点发生变化时，我们会直接更新原档案而不是另开新文。",
  },
  {
    q: "可以转载或引用你们整理的时间线吗？",
    a: "非商业用途注明来源即可引用；商业用途与内容合作请通过联系页面沟通，我们会在一个工作日内回复可行性与授权方式。",
  },
];

export interface PrincipleItem {
  icon: string;
  title: string;
  desc: string;
}

export const principles: PrincipleItem[] = [
  {
    icon: "ri-focus-3-line",
    title: "只做公开信息",
    desc: "所有节点必须能在公开渠道找到出处，不采信匿名爆料，不对私人生活做推演。",
  },
  {
    icon: "ri-time-line",
    title: "先时间线，后观点",
    desc: "把事实按时间顺序排好，再谈因果。顺序错了，结论就容易站不住脚。",
  },
  {
    icon: "ri-edit-2-line",
    title: "持续修订",
    desc: "有新节点就更新原档案，文末保留修订记录，让读者看到信息是怎么变的。",
  },
  {
    icon: "ri-shield-check-line",
    title: "标注存疑",
    desc: "证据不足的部分明确写「存疑」，不把推测包装成定论，这是底线。",
  },
];

export interface VoiceItem {
  name: string;
  role: string;
  text: string;
}

export const voices: VoiceItem[] = [
  {
    name: "陆知行",
    role: "娱乐产业观察者",
    text: "最难得的是它们愿意花时间把顺序排清楚。很多争议本身并不复杂，乱的是信息出现的先后被搅在一起。",
  },
  {
    name: "沈白",
    role: "内容编辑",
    text: "写稿时会把时间线单独拉一张表，节点对不上就退回重查。这种克制的写法在当下其实很少见。",
  },
  {
    name: "何予安",
    role: "长期读者",
    text: "以前刷到旧闻总是断断续续，现在习惯先来这里看完整时间线，再决定要不要追后续。",
  },
];

export const contactInfo = {
  email: "editor@midnight-archive.example",
  businessEmail: "partner@midnight-archive.example",
  tipEmail: "tips@midnight-archive.example",
  responseTime: "工作日 1 个工作日内回复",
};